import { CopyOutlined } from "@ant-design/icons";
import { Button, Flex, Modal, notification, Spin, Typography } from "antd";
import { FC } from "react";
import { useTranslation } from "react-i18next";

const { Paragraph } = Typography;

interface IBarcodesShowProps {
  loading: boolean;
  open: boolean;
  barcodes: Array<string>;
  barcodesCount: number;
  onCancel: () => void;
}

export const BarcodesShow: FC<IBarcodesShowProps> = ({loading, open, barcodes, barcodesCount, onCancel}) => {
  const { t } = useTranslation();

  const copyAllBarcodes = async () => {
    if(barcodes && barcodes.length > 0) {
      try {
        const allBarcodes = barcodes.join('\n');
        await navigator.clipboard.writeText(allBarcodes);
        notification.success({ placement: 'top',message: t('order.copySuccess')})
      } catch (error) {
        const errorMes = error instanceof Error ? error.message : t('order.copyFail')
        notification.error({ placement: 'top',message: errorMes})
      }
    }
  }

  const barcodeItemStyle = {
    backgroundColor: '#efefef', 
    borderRadius: '10px', 
    padding: '10px', 
    marginBottom: '10px',
  }

  return (
    <Modal
        style={{ top: 30 }}
        title={t('order.codeListWithCount',{count:barcodesCount})}
        open={open} 
        footer={null} 
        onCancel={onCancel}
      >
        {loading && <Spin style={{display: 'flex', justifyContent: 'center'}}/>}
        {barcodes && barcodes.length > 0 &&
          <>
            <div style={{textAlign: 'right'}}>
              <Button type="primary" icon={<CopyOutlined />} onClick={() => copyAllBarcodes()}>{t('order.copyAll')}</Button>
            </div>
            <div style={{maxHeight: '80vh', overflowY: 'auto', marginTop: '10px'}}>
              {barcodes.map((item: string, index: number) => (
                <Flex justify="start" key={index} style={barcodeItemStyle}>
                  <span>{index + 1}：</span>
                  <Paragraph copyable style={{marginBottom: '0'}}>{item}</Paragraph>
                </Flex>
              ))}
            </div>
          </>
        }
    </Modal>
  )
}